// Get request with record IDs as params
export default function(tableId) {

  $('.get-bulk').off().on('click', function() {
    let url = $(this).data('url');
    let params = {};
    let paramKey = $(this).data('param-key');
    params[paramKey] = $('#' + tableId).data('record-ids');
    if (url.indexOf('?') === -1) {
      url = url + '?';
    } else {
      url = url + '&';
    }
    Turbo.visit(url + $.param(params));
  })

}